export default __webpack_public_path__ + "static/media/qualification.d443fbcd.svg";